<template>
  <!-- 括弧で囲んで表示されることがあるため、span の内側の先頭と末尾に空白を入れない -->
  <span data-testid="signal-strength-indicator"
    ><template v-if="presentation"
      ><v-icon :size="size" data-testid="signal-strength-icon">{{ presentation.icon }}</v-icon>
      {{ $t(presentation.labelKey) }}</template
    ><template v-else>{{ $t('signal_strength.unknown') }}</template
  ></span>
</template>

<i18n lang="yaml">
ja:
  signal_strength:
    strong: '強'
    middle: '中'
    weak: '弱'
    poor: '微弱'
    none: '圏外'
    # 一度も取得できていない状態。
    unknown: '--'
en:
  signal_strength:
    strong: 'Strong'
    middle: 'Middle'
    weak: 'Weak'
    poor: 'Poor'
    none: 'Out of range'
    unknown: '--'
</i18n>

<script>
// RatSense の通信強度。バックエンドが Cre8tec の値を strong / middle / weak / poor / none へ
// 正規化して返す。一度も取得できていない場合は属性そのものが無く null になる。
//
// 段階ごとの表示。色では段階を表さず、点灯するバーの本数で示す（poor はバー 0 本）。
// 圏外はバー 0 本の poor と見分けるため、斜線入りのアイコンにする。
// 値を持たない場合は表に載せず、代わりに -- を出す。今の呼び出し元は値が無ければ
// この部品ごと出さないため通常は到達しないが、prop に null を受けたときの表示として残す。
const PRESENTATIONS = {
  strong: { icon: 'mdi-signal-cellular-3', labelKey: 'signal_strength.strong' },
  middle: { icon: 'mdi-signal-cellular-2', labelKey: 'signal_strength.middle' },
  weak: { icon: 'mdi-signal-cellular-1', labelKey: 'signal_strength.weak' },
  poor: { icon: 'mdi-signal-cellular-outline', labelKey: 'signal_strength.poor' },
  none: { icon: 'mdi-signal-off', labelKey: 'signal_strength.none' },
};

export default {
  name: 'signal-strength-indicator',
  props: {
    signalStrength: String,
    size: [Number, String],
  },
  computed: {
    presentation() {
      return PRESENTATIONS[this.signalStrength] || null;
    },
  },
};
</script>
